import { useState } from 'react'
import './index.scss'

import { useAuth } from '@auth/AuthProvider'
import Modal, { ModalButtonStyle } from '@components/Modal'
import LaunchpadController from '@data/controller/LaunchpadController'
import { Launchpad } from '@interfaces/launchpad.interface'

import closeIcon from 'url:@icon/close.svg';
import warningIcon from 'url:@icon/error-icon.svg';

export default function DeleteLaunchpadModal(props: {
  isOpen: boolean,
  launchpad?: Launchpad | null,
  close: () => void,
  onDeleted: () => void
}) {
  const auth = useAuth();
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteLaunchpad = async () => {
    if (!auth.churchId || !props.launchpad) {
      setError('Missing Launchpad context. Please refresh and try again.');
      return;
    }

    setIsDeleting(true);
    setError(null);

    try {
      const response = await LaunchpadController.deleteLaunchpad(auth.churchId, props.launchpad.launchpadID, auth);

      if (response.error) {
        setError(response.error);
        setIsDeleting(false);
        return;
      }

      props.onDeleted();
    } finally {
      setIsDeleting(false);
    }
  };

  return <Modal
    id='delete-launchpad-modal'
    isOpen={props.isOpen}
    footerButtons={[
      {
        title: 'Delete Launchpad',
        style: ModalButtonStyle.FILLED,
        enabled: !isDeleting,
        onClick: deleteLaunchpad
      },
      {
        title: 'Cancel',
        style: ModalButtonStyle.OUTLINE,
        enabled: !isDeleting,
        onClick: props.close
      }
    ]}>
    <div className='delete-launchpad-modal-content'>
      <div className='header'>
        <a aria-disabled={isDeleting}
          className={isDeleting ? 'close disabled' : 'close'}
          href='#'
          onClick={(e) => {
            e.preventDefault();

            if (isDeleting) {
              return;
            }

            props.close();
          }}>
          <img className='icon' src={closeIcon} alt='Close icon' />
        </a>

        <h3 className='title'>Delete {props.launchpad?.metadata.attributes.name ?? 'Launchpad'}</h3>
      </div>

      {error ? <p className='save-error'>{error}</p> : null}

      <div className='body'>
        <img src={warningIcon} alt='' aria-hidden='true' className='warning-icon' />

        <p className='warning-copy'>
          Deleting a Launchpad View will permanently remove its configuration and links. This action cannot be undone. Would you like to delete the Launchpad View?
        </p>
      </div>
    </div>
  </Modal>
}
